module.exports = __webpack_public_path__ + "static/media/20000d_p.1027448c.jpg";